/**
 * Side menu bar (in left).
 * Modify ic.menu variable for change menu items.
 * Warning! Only 2 level supported
 */

(function () {
    'use strict';

    angular.module('app').directive('sidebar', Sidebar);

// Directive    
    Sidebar.$inject = ['$location', '$rootScope', 'BusinessService'];

    function Sidebar($location, $rootScope, BusinessService) {

        var innerController = function () {
            var ic = this;
            // var isPrimeFuel = appConfig.platformParams.main_site.en === 'prime-fuel.com'
            // var isTmyasa = appConfig.platformParams.main_site.en === 'tmyasa.com.ua'
            // var isGLO = appConfig.platformParams.main_site.en === 'myglo.com.ua'
            // var isParimatch = appConfig.platformParams.main_site.en === 'pmclub.bet'
            // var isInCust = appConfig.platformParams.main_site.en === 'incust.com'
            // var isTestApi = (appConfig.apiBase.indexOf('//testapi.') !== -1)
            ic.MENU_ITEMS = null;
            $rootScope.$watch('MENU_ITEMS', function (newValue, oldValue) {
                ic.MENU_ITEMS = angular.copy(newValue);
                if (ic.MENU_ITEMS) {
                    ic.MENU_ITEMS.push({
                        href: '/settings-menu',
                        title: 'Settings menu',
                        icon: 'fa fa-list-ol'
                    });
                    for (const key in ic.MENU_ITEMS) {
                        if (
                            !$rootScope.ENV.business.active ||
                            $rootScope.ENV.business.status.flag_tariff_plan_expired ||
                            $rootScope.ENV.business.status.flag_insufficient_funds_on_account
                        ) {
                            ic.MENU_ITEMS[key].disabled = !(ic.MENU_ITEMS[key].href == '/tariff' ||
                                ic.MENU_ITEMS[key].href == '/tariff/details' ||
                                ic.MENU_ITEMS[key].href == '/payment');

                        } else {
                            ic.MENU_ITEMS[key].disabled = false;
                        }
                    }
                    ic.selectItem(ic.menuByLocation());
                }
            });

            $rootScope.$watch('ENV.business', function (newValue, oldValue) {
                if (ic.MENU_ITEMS && newValue) {
                    ic.MENU_ITEMS.push({
                        href: '/settings-menu',
                        title: 'Settings menu',
                        icon: 'fa fa-list-ol'
                    });
                    for (const key in ic.MENU_ITEMS) {
                        if (
                            !$rootScope.ENV.business.active ||
                            $rootScope.ENV.business.status.flag_tariff_plan_expired ||
                            $rootScope.ENV.business.status.flag_insufficient_funds_on_account
                        ) {
                            ic.MENU_ITEMS[key].disabled = !(ic.MENU_ITEMS[key].href == '/tariff' ||
                                ic.MENU_ITEMS[key].href == '/tariff/details' ||
                                ic.MENU_ITEMS[key].href == '/payment');

                        } else {
                            ic.MENU_ITEMS[key].disabled = false;
                        }
                    }
                    ic.selectItem(ic.menuByLocation());
                }
            });

            ic.selectedItem = {};
            ic.getLocalizedPath = getLocalizedPathFromUrlByLang;

            /**
             * Selected item in menu
             */
            ic.selectItem = function (sel_item) {
                console.info('selectItem', sel_item);
                ic.selectedItem = sel_item;
                console.log(ic.MENU_ITEMS);

                for (var iroot in ic.MENU_ITEMS) {
                    var root_item = ic.MENU_ITEMS[iroot];
                    root_item.selected = sel_item === root_item;

                    var childSelected = false;
                    if (root_item.sub) {

                        for (var isub in root_item.sub) {
                            var sub_item = root_item.sub[isub];

                            sub_item.selected = sel_item === sub_item;
                            if (sub_item.selected) {
                                childSelected = true;
                            }

                            var subChildSelected = false;
                            if (sub_item.sub) {
                                for (var ksub in sub_item.sub) {
                                    var sub_sub_item = sub_item.sub[ksub];

                                    sub_sub_item.selected = sel_item === sub_sub_item;
                                    if (sub_sub_item.selected) {
                                        childSelected = true;
                                        subChildSelected = true;
                                    }
                                }
                            }

                            if (sub_item.selected || subChildSelected) {
                                sub_item.open = true;
                            } else {
                                sub_item.open = false;
                            }

                        }
                    }

                    if (root_item.selected || childSelected) {
                        root_item.open = true;
                    } else {
                        root_item.open = false;
                    }
                }
            };

            /**
             * Event click on menu item
             */
            ic.onItemClick = function (item, $event) {
                console.info('menu-item', item);
                if (item.href === '#') {
                    item.open = !item.open;
                    return false;
                }
                ic.toggleMenu();
                $('html,body').animate({scrollTop: 0}, 'fast');
            };

            ic.toggleMenu = function () {
                var toggle = angular.element(document.getElementById('responsive-menu-toggle'));
                if (toggle.css('display') === 'block')
                    toggle.click();
            };

            /**
             * Return menu item for current $location
             */
            ic.menuByLocation = function () {
                var url = $location.url();
                var path = $location.path();
                console.info('menu path', path);

                var subLinkLen = 0;
                var subLink = {};

                // Find subpath
                function checkIncludepath(menu) {
                    var result = path.indexOf(menu.href);
                    if (result != -1) {
                        result = menu.href.length;
                        if (result > subLinkLen) {
                            subLinkLen = result;
                            subLink = menu;
                        }
                    }
                }

                // Find by URL
                for (var iroot in ic.MENU_ITEMS) {
                    var root_item = ic.MENU_ITEMS[iroot];
                    if (url === root_item.href) {
                        return root_item;
                    }

                    if (root_item.sub) {
                        for (var isub in root_item.sub) {
                            var sub_item = root_item.sub[isub];

                            if (url === sub_item.href)
                                return sub_item;

                            if (sub_item.sub) {
                                for (var ksub in sub_item.sub) {
                                    var sub_sub_item = sub_item.sub[ksub];
                                    if (url === sub_sub_item)
                                        return sub_item;
                                }
                            }
                        }
                    }
                }

                // Find by path
                for (var iroot in ic.MENU_ITEMS) {
                    var root_item = ic.MENU_ITEMS[iroot];

                    if (path === root_item.href) {
                        return root_item;
                    } else {
                        checkIncludepath(root_item);
                    }

                    if (root_item.sub) {
                        for (var isub in root_item.sub) {
                            var sub_item = root_item.sub[isub];

                            if (sub_item.sub)
                                for (var ksub in sub_item.sub) {
                                    var sub_sub_item = sub_item.sub[ksub];
                                    if (path === sub_sub_item)
                                        return sub_item;
                                    else
                                        checkIncludepath(sub_sub_item);
                                }

                            if (path === sub_item.href)
                                return sub_item;
                            else
                                checkIncludepath(sub_item);
                        }
                    }
                }

                return subLink;
            };

            // ic.selectItem(ic.menuByLocation())
            $rootScope.$on('$locationChangeStart', function (event, next, current) {
                ic.selectItem(ic.menuByLocation());
            });

            $rootScope.$on('$routeChangeSuccess', function () {
                var isPublic = $.inArray($location.path(), ['/signin', '/signup']) > -1;
                if (!isPublic) {
                    // $rootScope.ENV.sidebarCollapsed = $cookies.get('sidebar_closed') == '1';
                    $rootScope.PAGE.style = 'admin-panel page-header-fixed page-sidebar-closed-hide-logo page-container-bg-solid page-content-white';
                    if ($rootScope.ENV.sidebar)
                        $rootScope.PAGE.style += ' page-sidebar-closed';
                }
            });

            /**
             * Return true if item can show as 'open'
             */
            ic.isOpen = function (item) {
                // console.info('isOpen', item);
                return (item.sub && (item.open || $rootScope.ENV.sidebar));
            };

            /**
             * Return true if item selected
             */
            ic.isSelected = function (item) {
                return !!item.selected;
            };

            /**
             * Return true if item contain Badge
             */
            ic.isBadge = function (item) {
                return (item.badge && item.badge > 0);
            };

            /**
             * Return true if item is visible
             */
            ic.isVisible = function (item) {
                return !item.hidden;
                // if (item) {
                //   if (!!item.checkVisibility) {
                //     if (item.visibilityScope && item.visibilityScope == 'reseller') {
                //       if ($rootScope.ENV.business.status) {
                //         return $rootScope.ENV.business.status.business_reseller == 1 ? true : false
                //       } else {
                //         return $rootScope.ENV.business.reseller == 1 ? true : false
                //       }
                //     } else if (!item.disabled || !item.visible || !item.hidden) {
                //       return false
                //     } else {
                //       return true
                //     }
                //   } else {
                //     return true
                //   }
                // } else {
                //   return true
                // }
            };

        };

        return {
            restrict: 'E',
            templateUrl: 'app/components/sidebar.html',
            controller: innerController,
            controllerAs: 'ic',
            bindToController: true,
            link: function (scope, element, attrs) {
            }
        };
    }
})();
